import React from 'react';
import Api from '../../Api.js';
import { ModalContainer, ModalDialog } from 'react-modal-dialog';

class MigratePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locs: [],
      orgs: [],
      templates: [],
      showModal: false,
      showErrorModal: false,
      errorMsg: '',
      kioskName: '',
      org: '',
      orgname: '',
      loc: '',
      locname: '',
      templateID: '',
      runningScript: false,
    };
  }

  componentDidMount() {
    Api.getOrgList().then((data) => {
      let orgList = data || [];
      this.setState({ orgs: orgList, org: orgList[0] });

      Api.getLocationList(orgList[0].id)
        .then((data) => {
          let locList = data || [];
          this.setState({ locs: locList, loc: locList[0] });
        })
        .catch(() => {
          this.handleShowError('Unable to fetch location list from dashapi');
        });
    });

    Api.getXTemplateList()
      .then((data) => {
        let templateList = data || [];
        this.setState({ templates: templateList, templateID: '' });
      })
      .catch(() => {
        this.handleShowError('Unable to fetch template list from dashapi');
      });
  }

  goToTemplateList() {
    this.props.handleSelect(2);
  }

  handleOrgChange(e) {
    let value = e.target.value;
    let filter = this.state.orgs.filter((org) => {
      return org.id == value;
    });
    let org = filter[0];
    this.setState({ org: org });
    Api.getLocationList(org.id)
      .then((data) => {
        let locList = data || [];
        this.setState({ locs: locList, loc: locList[0] });

      if (locList.length > 0) {
        this.getSerialNumber(locList[0].id)
      } else {
        this.handleShowError("This org have no location")
      }
    }).catch(()=>{
      this.handleShowError("Unable to fetch org list from dashapi")
    });
  }

  getSerialNumber(locationId) {
    Api.getSerialNumber(locationId).then((data) => {
      let sn = data.serialnumber || '';
      this.setState({ kioskName: sn });
    });
  }

  handleLocChange(e) {
    let value = e.target.value;
    let filter = this.state.locs.filter((loc) => {
      return loc.id == value;
    });
    let loc = filter[0];
    this.setState({ loc: loc });
    this.getSerialNumber(loc.id);
  }

  handleCloseError() {
    this.setState({
      showErrorModal: false,
      errorMsg: '',
    });
  }

  handleShowError(msg) {
    this.setState({
      showErrorModal: true,
      errorMsg: msg,
    });
  }

  vshChange(e) {
    let kioskName = e.target.value;
    // console.log("update kioskName", kioskName)
    this.setState({ kioskName });
  }

  templateChange(e) {
    let templateID = e.target.value;
    // console.log("update templateID", templateID)
    this.setState({ templateID });
  }

  handleCloseModal() {
    this.setState({
      showModal: false,
    });
  }

  handleShowModal() {
    this.setState({
      showModal: true,
    });
  }

  handleSubmit() {
    this.handleCloseModal()
    Api.startScript(this.state.kioskName, this.state.templateID)
      .catch(e => {
        this.handleShowError(e.message)
      });
    this.setState({runningScript: true})
  }

  render() {
    return (
      <div className='content'>
        <div className='pure-form pure-form-horizontal pure-g'>
          <div className='pure-control-group pure-u-1'>
            <div className='pure-u-1-4'></div>
            <div className='pure-u-1-2'>
              <label className='pure-u-1' style={{ color: 'gray' }}>
                Branch/Org
              </label>
              <select
                id='org'
                className='pure-input-1'
                style={{ height: '3.6em' }}
                onChange={this.handleOrgChange.bind(this)}
              >
                {this.state.orgs.map((org) => (
                  <option key={org.id} value={org.id}>
                    {org.name}
                  </option>
                ))}
              </select>
            </div>
            <div className='pure-u-1-4'></div>
          </div>

          <div className='pure-control-group pure-u-1'>
            <div className='pure-u-1-4'></div>
            <div className='pure-u-1-2'>
              <label className='pure-u-1' style={{ color: 'gray' }}>
                Location
              </label>
              <select
                id='location'
                className='pure-input-1'
                style={{ height: '3.6em' }}
                onChange={this.handleLocChange.bind(this)}
              >
                {this.state.locs.map((loc) => (
                  <option key={loc.id} value={loc.id}>
                    {loc.name}
                  </option>
                ))}
              </select>
            </div>
            <div className='pure-u-1-4'></div>
          </div>

          <div className='pure-control-group pure-u-1'>
            <div className='pure-u-1-4'></div>
            <div className='pure-u-1-2'>
              <label className='pure-u-1' style={{ color: 'gray' }}>
                VSH
              </label>
              <input
                value={this.state.kioskName}
                className='pure-input-1'
                style={{ height: '3.6em' }}
                onChange={this.vshChange.bind(this)}
              />
            </div>
            <div className='pure-u-1-4'></div>
          </div>

          <div className='pure-control-group pure-u-1'>
            <div className='pure-u-1-4'></div>
            <div className='pure-u-1-2'>
              <label className='pure-u-1' style={{ color: 'gray' }}>
                X Template
              </label>
              <select
                id='templateID'
                className='pure-input-1'
                defaultValue=''
                style={{ height: '3.6em' }}
                onChange={this.templateChange.bind(this)}
              >
                <option value=''>None</option>
                {this.state.templates.map((template) => (
                  <option key={template.name} value={template.id}>
                    {template.name}
                  </option>
                ))}
              </select>
            </div>
            <div className='pure-u-1-4'></div>
          </div>
          <div className='pure-control-group pure-u-1'>
            <div className='pure-u-1-4'></div>
            <button
              onClick={this.handleShowModal.bind(this)}
              style={{ marginTop: '1%', height: '3.6em' }}
              className='pure-button pure-button-primary pure-u-1-2'
            >
              RUN PORTING SCRIPT
            </button>
            <div className='pure-u-1-4'></div>
          </div>
        </div>
        {this.state.runningScript ? (
          <div
            ref='running-script'
            className='pure-control-group pure-u-1'
            style={{ marginTop: '30px' }}
          >
            <div className='pure-u-1-4'></div>
            <div className=' pure-u-1-2' style={{ marginTop: '40px' }}>
              <button
                className='pure-button pure-button-primary pure-u-1'
                style={{ height: '3.6em' }}
                onClick={this.goToTemplateList.bind(this)}
              >
                VIEW HISTORY RESULTS
              </button>
            </div>
            <div className='pure-u-1-4'></div>
          </div>
        ) : (
          <div />
        )}

        {this.state.showModal && (
          <ModalContainer>
            <ModalDialog>
              <div>
                <i
                  className='fa fa-exclamation-circle danger'
                  style={{ textAlign: 'center', fontSize: '50px', display: 'block' }}
                ></i>
              </div>
              <h1>ARE YOU SURE?</h1>
              <p style={{ textAlign: 'center' }}>
                You are about to Run Porting Script for the following:
              </p>
              <h3 style={{ color: 'red' }}>
                {this.state.kioskName || 'Unknown'} | {this.state.org.name} | {this.state.loc.name}
              </h3>
              <button className='pure-button pure-u-1-2' onClick={this.handleCloseModal.bind(this)}>
                CANCEL
              </button>
              <button
                className='pure-button pure-button-primary pure-u-1-2'
                onClick={this.handleSubmit.bind(this)}
              >
                CONTINUE
              </button>
            </ModalDialog>
          </ModalContainer>
        )}
        {this.state.showErrorModal && (
          <ModalContainer onClose={this.handleCloseError.bind(this)}>
            <ModalDialog>
              <h2>
                <i className='fa fa-exclamation-circle danger'></i> Error
              </h2>
              <div>{this.state.errorMsg}</div>
            </ModalDialog>
          </ModalContainer>
        )}
      </div>
    );
  }
}

export default MigratePage;



// WEBPACK FOOTER //
// ./src/components/pages/MigratePage.js